import { render, staticRenderFns } from "./WazdanFreespinsShowForm.vue?vue&type=template&id=361ad654&"
import script from "./WazdanFreespinsShowForm.vue?vue&type=script&lang=js&"
export * from "./WazdanFreespinsShowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports